const inr = new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 });

// GLOBAL_RULES.md §1.3: every money field in the ledger is integer PAISE (seed_commercial.py's
// own plan pricing confirms it — amount: 300000 for a documented ₹3,000/month plan). This is the
// single place that converts paise -> rupees for display; every caller passes the raw paise
// integer straight from the API, never dividing themselves.
export function formatCurrency(amountInPaise) {
  return inr.format((amountInPaise || 0) / 100);
}

export function formatCompactNumber(n) {
  return new Intl.NumberFormat("en-IN").format(n || 0);
}

export function timeAwareGreeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 17) return "Good afternoon";
  return "Good evening";
}

export function todayIso() {
  return new Date().toISOString().slice(0, 10);
}

// Date-range presets for the Owner Cockpit's period control — used by /reports/pnl and
// /reports/day-end (both period_start/period_end aware).
export function dateRangeFor(preset) {
  const now = new Date();
  const end = now.toISOString();
  if (preset === "today") {
    const start = new Date(now);
    start.setUTCHours(0, 0, 0, 0);
    return { period_start: start.toISOString(), period_end: end };
  }
  if (preset === "week") {
    const start = new Date(now);
    start.setUTCDate(start.getUTCDate() - 7);
    return { period_start: start.toISOString(), period_end: end };
  }
  // month
  const start = new Date(now);
  start.setUTCDate(start.getUTCDate() - 30);
  return { period_start: start.toISOString(), period_end: end };
}

export function relativeTimeFromNow(iso) {
  if (!iso) return "never";
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.floor(diffMs / 60000);
  if (mins < 1) return "just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

// Member search boxes across every persona (Desk lookup/Money-in, Owner Members, top-bar global
// search) all need to decide "is this query a phone number or a name" so they hit the right
// `GET /members` param. A query is treated as a phone search the moment it's made up of only
// digits/+/space/dash (even a partial 2-3 digit fragment) — the backend now does a partial
// regex match on `profile.phone` too, so this correctly supports incremental typed digits, not
// just a full 10-digit number.
export function isPhoneQuery(str) {
  const trimmed = (str || "").trim();
  return trimmed.length > 0 && /^[\d+\s-]+$/.test(trimmed) && /\d/.test(trimmed);
}

// `me.permissions` is either a real list (`["member.view", ...]`) or the super_admin wildcard
// `["*"]` — every per-screen permission check across the app (Members' Dues-outstanding/At-risk
// tabs, Desk's Override/Mandate buttons, etc.) needs to treat the wildcard as "yes to everything"
// rather than a literal string match, so it's centralized here once instead of re-deriving
// `role === "super_admin"` at every call site.
export function hasPermission(me, permission) {
  return Boolean(me?.permissions?.includes("*") || me?.permissions?.includes(permission));
}
